import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Login from "./pages/Login/Login";
import Home from "./pages/Home/Home";
import Employes from "./pages/Employes/Employes";
import Invoices from "./pages/Invoices/Invoices";
import InvoicesExpress from "./pages/Invoices/InvoicesExpress";
import Contracts from "./pages/Contracts/Contracts";
import ControlPanel from "./pages/Control-panel/Control-panel";
import Header from "./pages/Header/Header";
import "./App.css";
import ConsultInvoices from "./pages/Invoices/ConsultInvoices";

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const user = localStorage.getItem("user");
    setIsAuthenticated(!!user);
  }, []);

  const handleLogout = () => {
    setIsAuthenticated(false); // Actualizar estado de autenticación
  };

  return (
    <Router>
      {isAuthenticated && <Header onLogout={handleLogout} />}
      <Routes>
        <Route
          path="/login"
          element={
            isAuthenticated ? <Navigate to="/home" /> : <Login onLogin={() => setIsAuthenticated(true)} />
          }
        />
        <Route
          path="/"
          element={
            isAuthenticated ? <Navigate to="/home" /> : <Navigate to="/login" />
          }
        />
        {isAuthenticated && (
          <>
            <Route path="/home" element={<Home />} />
            <Route path="/employes" element={<Employes />} />
            <Route path="/invoices" element={<Invoices />} />
            <Route path="/invoices-express" element={<InvoicesExpress />} />
            <Route path="/consult-invoices" element={<ConsultInvoices />} />
            <Route path="/contracts" element={<Contracts />} />
            <Route path="/control-panel" element={<ControlPanel />} />
          </>
        )}
        <Route path="*" element={<Navigate to={isAuthenticated ? "/home" : "/login"} />} />
      </Routes>
    </Router>
  );
}

export default App;